import { AlertModal } from "../../components/Modals/AlertModal/AlertModal";
import { Edit, Trash, More } from "@rsuite/icons";
import React, { useState } from "react";
import { Popover, Dropdown, IconButton, Whisper } from "rsuite";
import ViewChart from "./ViewChart";
import { useDispatch } from "react-redux";
import { setActionData } from "../../../redux/userActionData";
import { useNavigate } from "react-router-dom";
import { statusArr } from "../../../core/config/AppConstants";
import { useTranslation } from "react-i18next";
import { encryptUrl } from "../../../navigation/useDecryptParams";
import { ContentRoutes } from "../../../navigation/NavConstant";

const ChartSingleAction = ({
  chartData,
  onDeleteChart,
  onPublishChart,
  permission,
  ...props
}: {
  chartData: any;
  onDeleteChart: Function;
  onPublishChart: Function;
  permission: any;
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [openModalByName, setOpenModalByName] = useState("");
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [openPublishModal, setOpenPublishModal] = useState(false);
  const [publishMessage, setPublishMessage] = useState("");
  const ecryptedChartId = encryptUrl(`${chartData.id}`);

  const chartUpdateLink = ContentRoutes.UPDATE_CHART.replace(
    ":id",
    ecryptedChartId.toString()
  );
  const navigate = useNavigate();
  const publishText =
    chartData.status == statusArr.active
      ? t("UNPUBLISH").toLowerCase()
      : t("PUBLISH").toLowerCase();
  const pMessage = t("CONFIRM_ACTION", {
    action:
      chartData.status == statusArr.active
        ? t("UNPUBLISH").toLowerCase()
        : t("PUBLISH").toLowerCase(),
    entity: t("CHART").toLowerCase(),
  });

  const renderMenu = (
    {
      onClose,
      left,
      top,
      className,
    }: { onClose: any; left: any; top: any; className: any },
    ref:
      | ((instance: HTMLDivElement | null) => void)
      | React.RefObject<HTMLDivElement>
      | null
      | undefined
  ) => {
    const handleSelect = (eventKey: any) => {
      if (eventKey == "view-chart") {
        setOpenModalByName(eventKey);
        dispatch(setActionData(chartData));
        onClose && onClose();
      } else if (eventKey == "edit-chart") {
        handleEditAction();
      } else if (eventKey == "publish-chart") {
        setOpenPublishModal(true);
        setPublishMessage(pMessage);
      } else if (eventKey == "delete-chart") {
        setOpenDeleteModal(true);
      }
    };
    return (
      <Popover ref={ref} className={className} style={{ left, top }} full>
        <Dropdown.Menu onSelect={handleSelect}>
          <Dropdown.Item eventKey={"view-chart"}>{t("VIEW")}</Dropdown.Item>
          {permission.update && (
            <Dropdown.Item eventKey={"edit-chart"}>{t("EDIT")}</Dropdown.Item>
          )}
          {permission.publish && (
            <Dropdown.Item eventKey={"publish-chart"}>
              {publishText}
            </Dropdown.Item>
          )}
          {permission.delete && (
            <Dropdown.Item eventKey={"delete-chart"}>
              {t("DELETE")}
            </Dropdown.Item>
          )}
        </Dropdown.Menu>
      </Popover>
    );
  };

  function handleEditAction() {
    navigate(`${chartUpdateLink}`);
  }
  return (
    <div>
      <Whisper
        placement="topEnd"
        trigger="click"
        speaker={renderMenu}
        preventOverflow={true}
      >
        <IconButton appearance="subtle" icon={<More />} />
      </Whisper>
      {openModalByName === "view-chart" && (
        <ViewChart
          status={openModalByName === "view-chart" ? true : false}
          toggle={setOpenModalByName}
        />
      )}
      <AlertModal
        open={openDeleteModal}
        handleClose={(e: any) => {
          if (e == true) {
            onDeleteChart(chartData);
            setOpenDeleteModal(false);
          } else {
            setOpenDeleteModal(false);
          }
        }}
        displayText={t("CONFIRM_ACTION", {
          action: t("DELETE").toLowerCase(),
          entity: t("CHART").toLowerCase(),
        })}
        modalTitle={t("CONFIRM_ACTION_TITLE", {
          action: t("DELETE").toLowerCase(),
        })}
      />
      <AlertModal
        open={openPublishModal}
        handleClose={(e: any) => {
          if (e == true) {
            onPublishChart(chartData);
            setOpenPublishModal(false);
          } else {
            setOpenPublishModal(false);
          }
        }}
        displayText={publishMessage}
      />
    </div>
  );
};

export default ChartSingleAction;
